import { removePrivateVariablesFromBody } from '@/Helpers/object';

export const RequestRemovePrivateVariables = conf => {
  if (conf.method === 'get') {
    return conf;
  }
  try {
    const data = JSON.parse(JSON.stringify(conf.data));
    conf.data = removePrivateVariablesFromBody(data);
    return conf;
  } catch (e) {
    return conf;
  }
};
